import React from "react";
import Slider from "react-slick";
import VideoThumbnail from "../../assets/icons/video_thumnail.png";
import { Button } from "@mui/material";
import NextArrow from "../../assets/icons/Nextarrow.png";
import PrevArrow from "../../assets/icons/Prevarrow.png";
import Client_TataIcon from '../../assets/icons/Client_TataIcon.png';
import Client_SageIcon from '../../assets/icons/Client_SageIcon.png';
import Client_TVSICon from '../../assets/icons/Client_TVSICon.png';
import Client_MahindraIcon from '../../assets/icons/Client_MahindraIcon.png';
import Client_AGP_Icon from '../../assets/icons/Client_AGP_Icon.png';
import Client_Hinduja_Icon from '../../assets/icons/Client_Hinduja_Icon.svg'
import Client_tresata_Icon from '../../assets/icons/Client_tresata_Icon.jpg'
import Client_Ramco_Icon from '../../assets/icons/Client_Ramco_Icon.png'
import Client_ITC_Limited from '../../assets/icons/Client_ITC_Limited.png'
import Client_randstad_Icon from '../../assets/icons/Client_randstad_Icon.png'


import { 
  ClientSpotlightContainer,
  ClientSpotlightTitleContainer,
  ClientSpotlightSliderContainer,
  ClientSpotlightSliderImage,
  ClientSpotlightNextArrowStyled,
  ClientSpotlightPrevArrowStyled,
  ClientSpotlightVideoSection,
  ClientSpotlightVideoBox,
  ClientSpotlightVideoThumbnailImg,
  ClientSpotlightPlayButton,
  ClientSpotlightRightSection,
  ClientSpotlightTitle,
  ClientSpotlightSubTitle,
  ClientSpotlightDescription,
  IconContainer,
  ClientIcon
} from '../../assets/styles/HomeStyles';
import { useNavigate } from "react-router-dom";

const ClientSpotlight = () => {
  const navigate = useNavigate();

  const icons = [
    Client_TataIcon,
    Client_SageIcon, 
    Client_TVSICon, 
    Client_MahindraIcon, 
    Client_AGP_Icon, 
    Client_Hinduja_Icon,
    Client_Ramco_Icon,
    Client_ITC_Limited,
    Client_randstad_Icon,
    Client_tresata_Icon];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    nextArrow: <ClientSpotlightNextArrowStyled src={NextArrow} alt="Next" />,
    prevArrow: <ClientSpotlightPrevArrowStyled src={PrevArrow} alt="Prev" />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <ClientSpotlightContainer>
      <ClientSpotlightTitleContainer>CLIENT SPOTLIGHT</ClientSpotlightTitleContainer>
      <ClientSpotlightSliderContainer>
        <Slider {...settings}>
          {[...Array(10)].map((_, index) => (
            <div key={index}>
            <ClientSpotlightSliderImage>
                <IconContainer>
                  <ClientIcon src={icons[index]} alt={`Icon ${index + 1}`} />
                </IconContainer>
              </ClientSpotlightSliderImage>
            </div>
          ))}
        </Slider>
      </ClientSpotlightSliderContainer>
      <ClientSpotlightVideoSection>
        <ClientSpotlightVideoBox>
          <ClientSpotlightVideoThumbnailImg src={VideoThumbnail} alt="Video Thumbnail" />
          <ClientSpotlightPlayButton>▶</ClientSpotlightPlayButton>
        </ClientSpotlightVideoBox>
        <ClientSpotlightRightSection>
          <ClientSpotlightTitle>Safety is for Everyone</ClientSpotlightTitle>
          <ClientSpotlightSubTitle>
            Every day, we make countless decisions. Some big, some small. But
            how often are these choices truly informed?
          </ClientSpotlightSubTitle>
          <ClientSpotlightDescription>
            Whether you’re hiring someone, choosing a partner, or navigating
            daily choices, every decision has its consequences. That's where we
            come in to give you the freedom to choose and freedom to design your
            risk parameters.
          </ClientSpotlightDescription>
          <ClientSpotlightDescription>
            Devia not only manages the unorganised data, the mundane tasks, the
            instant checks, but also our domain experts analyse and extract
            valuable insights.
          </ClientSpotlightDescription>
          <ClientSpotlightDescription>
            What's most important is the analytics and insights across all
            departments can be shared at the click of a button enabling informed
            decision making.
          </ClientSpotlightDescription>
          <Button className="custom-button" variant="contained"  onClick={() => navigate("/contact-us")}> 
            Get Demo
          </Button>
        </ClientSpotlightRightSection>
      </ClientSpotlightVideoSection>
    </ClientSpotlightContainer>
  );
};

export default ClientSpotlight;
